import { Module } from 'vuex'
import { RootState } from '@/store/types'
import { GroupFormationState } from '@/store/groups/formation/types'
import mutations from './mutations'
import actions from './actions'
import getters from './getters'

const Groups: Module<GroupFormationState, RootState> = {
  state: (): GroupFormationState => ({
    assignments: [],
  }),
  mutations,
  actions,
  getters,
}

export default Groups
